import React from "react";
import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function CanastaGameInfo() {
  return (
    <div className="p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Canasta" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Canasta</h1>
      <img
        src="/thumbnails/Canasta.png"
        alt="Canasta game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Canasta</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Canasta is a classic card game of the Rummy family, invented in Uruguay in 1939 and quickly spreading in popularity across the Americas and Europe. The game is played with two standard decks of cards (including jokers), and the goal is to form melds of seven or more cards of the same rank, called "canastas." Canasta is known for its strategic depth, wild cards, and the excitement of building and capturing large melds.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Canasta is usually played by 2-6 players, most commonly in partnerships of two.</li>
          <li>Players draw and discard cards, aiming to form melds of at least three cards of the same rank.</li>
          <li>Jokers and twos are wild cards and can be used in melds.</li>
          <li>A "canasta" is a meld of seven or more cards of the same rank.</li>
          <li>The round ends when a player goes out by discarding their last card.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">History</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Canasta was created by Segundo Santos and Alberto Serrato in Montevideo, Uruguay. It became a craze in the United States in the 1950s, rivaling Bridge in popularity. The name "Canasta" means "basket" in Spanish, referring to the basket used to hold the cards.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Strategy Tips</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Keep track of wild cards and use them wisely.</li>
          <li>Try to build canastas early, but don't reveal your hand too soon.</li>
          <li>Pay attention to your opponents' discards and melds.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Canasta</h2>
          <p className="text-gray-700 dark:text-gray-300">
          You can play Canasta for free with friends or other players right here on Game for a Laugh! No download or registration required.
        </p>   
        <PlayGameLink game="Canasta" />
      </section>
    </div>
  );
}
